import React from "react";
import { Grid, TextField } from '@mui/material';

export default function FormPrecios(props) {
    const { style, size, almacenar, datoslista } = props;

    return (
        <>
            {datoslista &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    mt={1}
                >

                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_sin_iva"
                            label="Precio sin IVA"
                            variant="outlined"
                            value={isNaN(datoslista.precio_sin_iva) ? 0 : datoslista.precio_sin_iva}
                            onChange={almacenar}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_iva"
                            label="Precio litro con IVA"
                            variant="outlined"
                            value={isNaN(datoslista.precio_iva) ? 0 : datoslista.precio_iva}
                            onChange={almacenar}
                        />
                    </Grid>




                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            type="date"
                            name="vigencia"
                            label="Vigencia"
                            variant="outlined"
                            value={datoslista.vigencia}
                            onChange={almacenar}
                        />
                    </Grid>
                </Grid>
            }
        </>

    )
}